
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cDMVr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ecce27880645537302fdbdc3f16ef72c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $933f141c99b2ec32$var$_react = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("42omo")));

var $933f141c99b2ec32$var$_baseNew = $933f141c99b2ec32$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $933f141c99b2ec32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-add
 * Usage guidance:
 * Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $933f141c99b2ec32$var$PersonAddIcon = (props)=>/*#__PURE__*/ $933f141c99b2ec32$var$_react.default.createElement($933f141c99b2ec32$var$_baseNew.default, Object.assign({
        name: "PersonAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 12.75A3.75 3.75 0 0 1 4.75 9H9v1.5H4.75a2.25 2.25 0 0 0-2.25 2.25V15H1zM9.5 4a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M11 4a4 4 0 1 1-8 0 4 4 0 0 1 8 0m2.75 6v2.25H16v1.5h-2.25V16h-1.5v-2.25H10v-1.5h2.25V10z"/>`
    }, props));
$933f141c99b2ec32$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $933f141c99b2ec32$var$_default = module.exports.default = $933f141c99b2ec32$var$PersonAddIcon;

});


//# sourceMappingURL=person-add.961e3a61.js.map
